<template>
    <v-select
        v-if="shippingProvidersItems.length"
        v-model="selectedProvider"
        :items="shippingProvidersItems"
        class="input-no-spacing"
        :class="shippingProvidersItems.length > 1 ? '' : 'd-none'"
    ></v-select>
</template>

<script>
    import ShippingSelector from '../ShippingSelector';
    import {mapState, mapMutations, mapActions} from 'vuex';

    const moduleName = 'ShippingProvider';

    export default {
        name: moduleName,
        props: {
            actualPricesLoaded: {
                type: Boolean,
                default: true,
            },
        },
        created() {
            this.loadPossibleShippingCountries().then(() => {
                this.loadShippingPricesProviders();
            });
        },
        computed: {
            ...mapState(ShippingSelector.name, [
                'shippingProviders',
                'shippingCountries',
                'selectedShippingProvider',
            ]),
            selectedProvider: {
                get() {
                    return this.selectedShippingProvider;
                },
                set(value) {
                    this.setSelectedShippingProvider(value);
                },
            },
            shippingProvidersItems() {
                let items = [];

                for (let provider of Object.values(this.shippingProviders)) {
                    items.push({
                        text: provider.title,
                        value: provider.id,
                    });

                    if (!this.selectedProvider) {
                        this.selectedProvider = provider.id;
                    }
                }

                return items;
            },
            getLastBasketChange() {
                return this.$basket.getLastBasketChange();
            },
            selectedCountry() {
                return this.$country.getCountry();
            }
        },
        methods: {
            ...mapMutations(ShippingSelector.name, [
                'setSelectedShippingProvider',
            ]),
            ...mapActions(ShippingSelector.name, [
                'loadShippingPricesProviders',
                'loadPossibleShippingCountries',
            ]),
        },
        watch: {
            getLastBasketChange() {
                if (this.actualPricesLoaded) {
                    this.loadShippingPricesProviders();
                }
            },
            selectedCountry() {
                this.setSelectedShippingProvider(null);
            },
        },
    };
</script>